export async function api(path, options = {}) {
  const response = await fetch("/api" + path, {
    credentials: "same-origin",
    headers: { "content-type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  if (response.status === 401) throw Object.assign(new Error("Authentication required"), { status: 401 });
  if (response.status === 403) throw Object.assign(new Error("You do not have access to this action"), { status: 403 });
  const data = response.headers.get("content-type")?.includes("json") ? await response.json() : null;
  if (!response.ok) throw Object.assign(new Error(data?.message || data?.error || "Request failed"), { status: response.status, data });
  return data;
}

export function slugify(value) {
  return value.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}
